<template>
	<div class="about">
		<div class="section">
			<h2 class="section-title" id="why">Perchè siamo diversi dalle altre palestre?</h2>
			<div class="container-desktop pad-l">
				<ul style="font-size: 1.2em;">
				<li><b>Non abbiamo vincoli di abbonamento</b>, facciamo pacchetti da 10/20 ingressi che non hanno scadenza e che potrai usare quando vuoi!</li>

				<li>Non c’è possibilità di allenarsi da soli, riceviamo <b>sempre su appuntamento</b> mantenendo controllati gli ingressi per garantire sempre <b>massima qualità e sicurezza!</b></li>

				<li>Gli allenamenti sono <b>sempre seguiti</b> da coach qualificati e laureati, e <b>personalizzati</b> in base alle esigenze del cliente</li>

				<li>Non abbiamo macchinari e non eseguiamo il classico allenamento delle palestre, la nostra priorità è <b>la qualità dei movimenti</b>, provare per credere!</li>

				<li>Eseguiamo sempre batterie di <b>test iniziali</b></li>
				</ul>
				<img src="@/assets/Palestra_home1.jpg" alt="personal trainer seregno" style="width: 100%;"> 
			</div>
			<h2 class="section-title">La nostra visione</h2>

			<div class="container-desktop pad-l">
				<ShowMore class="info">
					Eximus ambisce a diventare un punto di riferimento per tutti coloro che vogliano intraprendere un percorso personalizzato di allenamento funzionale migliorando il movimento, la salute, l’aspetto del proprio corpo e per tutti gli atleti che vogliano una preparazione atletica specifica e di alta qualità.
					Eximus crede fermamente nella filosofia secondo cui “se hai un corpo sei un atleta”. Proponiamo la qualità dell’allenamento, preferendola alla quantità, allenando i movimenti e non i singoli muscoli.
					Eximus propone un percorso di crescita graduale, partendo dall’insegnamento dei movimenti fondamentali per poi arrivare a quelli più complessi, mettendo sempre al primo posto la tecnica.
					Crediamo che l’allenamento non debba essere distruttivo, ma debba dare alla persona l’energia per affrontare la vita di tutti i giorni con una spinta in più.
					L’allenamento di Eximus è totale perché in ogni sessione alleniamo tutte le qualità del corpo: mobilità, potenza, forza e resistenza.
				</ShowMore>
				<!-- <div class="info phone">
					Eximus ambisce a diventare un punto di riferimento per tutti coloro che vogliano intraprendere un percorso personalizzato di allenamento funzionale migliorando il movimento, la salute, l’aspetto del proprio corpo e per tutti gli atleti che vogliano una preparazione atletica specifica e di alta qualità.
					Eximus crede fermamente nella filosofia secondo cui “se hai un corpo sei un atleta”. Proponiamo la qualità dell’allenamento, preferendola alla quantità, allenando i movimenti e non i singoli muscoli.
				</div> -->
				<div class="info">
					<div class="divprova">
						<a href="#trial"><button class="provagratuita" id="provagratuita">Prenota una PROVA GRATUITA!</button></a>
					</div>
				</div>
			</div>

			<!--<div class="gridebook" id="ebook">
				<div class="itemebook">
					<h2 class="section-title">Allenati con noi !</h2>
						<h3 align="center">Scegli la scheda che preferisci e inizia ad allenarti!</h3>
				</div>
				<div class="itemebook">
					<h1 align="center"><a href="#form_estate1"><img id="estate1" src='@/assets/scheda-bw.jpg' class="left" @click="attiva_estate1()"></a><a href="#form_estate2"><img id="estate2" src='@/assets/scheda-db.jpg' @click="attiva_estate2()"></a></h1>
				</div>
			</div>

				<div id="form_estate1" class="container-desktop pad-l ebook1">
					<div class="contact-form">
						<form class="pad-l" @submit.prevent="submitEstate1">
							<div class="title">Scarica subito la <b>scheda a corpo libero</b> per iniziare ad allenarti!</div>

							<div class="input-grid">
								<div class="form-input">
									<label>Nome</label>
										<input type="name" v-model="formData.name" name="name" placeholder="Nome" required/>
									<label>Cognome</label>
										<input type="name" v-model="formData.surname" name="surname" placeholder="Cognome" required/>
									<label>Email</label>
										<input type="email" v-model="formData.email" name="email" placeholder="Email" required/>
								</div>
								<div class="submit">
									<button>SCARICA SUBITO!</button>
								</div>
							</div>
						</form>
					</div>
				</div>
				<div id="form_estate2" class="container-desktop pad-l ebook1">
					<div class="contact-form">
						<form class="pad-l" @submit.prevent="submitEstate2">
							<div class="title">Scarica subito la <b>scheda con attrezzi</b> per iniziare ad allenarti!</div>

							<div class="input-grid">
								<div class="form-input">
									<label>Nome</label>
										<input type="name" v-model="formData.name" name="name" placeholder="Nome" required/>
									<label>Cognome</label>
										<input type="name" v-model="formData.surname" name="surname" placeholder="Cognome" required/>
									<label>Email</label>
										<input type="email" v-model="formData.email" name="email" placeholder="Email" required/>
								</div>
								<div class="submit">
									<button>SCARICA SUBITO!</button>
								</div>
							</div>
						</form>
					</div>
				</div>-->

			<div class="gridebook" id="ebook">
				<div class="itemebook">
					<h2 class="section-title">Scarica gratis i nostri ebook !</h2>
					<h3 align="center">Seleziona l'ebook che preferisci e scaricalo subito!</h3>
				</div>
				<div class="itemebook">
					<h1 align="center">
						<a href="#form_quattro"><img id="quattro" src='@/assets/ginocchia.jpg' class="left" @click="attiva_quattro()"></a>
						<a href="#form_tre"><img id="tre" src='@/assets/copertina-libro3.jpg' class="left" @click="attiva_tre()"></a>
						<a href="#form_right"><img id="right" src='@/assets/copertina-libro2.jpg' class="left" @click="attiva_right()"></a>
						<a href="#form_left"><img id="left" src='@/assets/copertina-libro1.png' @click="attiva_left()"></a>
					</h1>
				</div>
			</div>

				<div id="form_left" class="container-desktop pad-l ebook1">
					<div class="contact-form">
						<form class="pad-l" @submit.prevent="submitEbook1">
							<div class="title">Scarica subito l'eBook gratuito - 10 motivi per cui fallisci in palestra</div>

							<div class="input-grid">
								<div class="form-input">
									<label>Nome</label>
										<input type="name" v-model="formData.name" name="name" placeholder="Nome" required/>
									<label>Cognome</label>
										<input type="name" v-model="formData.surname" name="surname" placeholder="Cognome" required/>
									<label>Email</label>
										<input type="email" v-model="formData.email" name="email" placeholder="Email" required/>
								</div>
								<div class="submit">
									<button>SCARICA SUBITO!</button>
								</div>
							</div>
						</form>
					</div>
				</div>
				<div id="form_right" class="container-desktop pad-l ebook1">
					<div class="contact-form">
						<form class="pad-l" @submit.prevent="submitEbook2">
							<div class="title">Scarica subito l'eBook gratuito - Come (ri)iniziare ad allenarsi</div>

							<div class="input-grid">
								<div class="form-input">
									<label>Nome</label>
										<input type="name" v-model="formData.name" name="name" placeholder="Nome" required/>
									<label>Cognome</label>
										<input type="name" v-model="formData.surname" name="surname" placeholder="Cognome" required/>
									<label>Email</label>
										<input type="email" v-model="formData.email" name="email" placeholder="Email" required/>
								</div>
								<div class="submit">
									<button>SCARICA SUBITO!</button>
								</div>
							</div>
						</form>
					</div>
				</div>
				<div id="form_tre" class="container-desktop pad-l ebook1">
					<div class="contact-form">
						<form class="pad-l" @submit.prevent="submitEbook3">
							<div class="title">Scarica subito l'eBook gratuito - Come vivere meglio e più a lungo</div>

							<div class="input-grid">
								<div class="form-input">
									<label>Nome</label>
										<input type="name" v-model="formData.name" name="name" placeholder="Nome" required/>
									<label>Cognome</label>
										<input type="name" v-model="formData.surname" name="surname" placeholder="Cognome" required/>
									<label>Email</label>
										<input type="email" v-model="formData.email" name="email" placeholder="Email" required/>
								</div>
								<div class="submit">
									<button>SCARICA SUBITO!</button>
								</div>
							</div>
						</form>
					</div>
				</div>

				<div id="form_quattro" class="container-desktop pad-l ebook1">
					<div class="contact-form">
						<form class="pad-l" @submit.prevent="submitEbookKnee">
							<div class="title">Scarica subito l'eBook gratuito - Ginocchia a prova di runner</div>

							<div class="input-grid">
								<div class="form-input">
									<label>Nome</label>
										<input type="name" v-model="formData.name" name="name" placeholder="Nome" required/>
									<label>Cognome</label>
										<input type="name" v-model="formData.surname" name="surname" placeholder="Cognome" required/>
									<label>Email</label>
										<input type="email" v-model="formData.email" name="email" placeholder="Email" required/>
								</div>
								<div class="submit">
									<button>SCARICA SUBITO!</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			
			<div class="gridebook" id="scheda">
				<div class="itemebook">
					<h2 class="section-title">Prova la nostra routine di mobilità !</h2>
					<h3 align="center">Migliora la tua flessibilità, riduci i dolori e recupera più velocemente!</h3>
				</div>
				<div class="itemebook">
					<h1 align="center"><a href="#form_routine"><img id="routine" src='@/assets/routine.jpg' class="left" @click="attiva_routine()"></a></h1>
				</div>
			</div>

			<div id="form_routine" class="container-desktop pad-l ebook1">
					<div class="contact-form">
						<form class="pad-l" @submit.prevent="submitScheda">
							<div class="title">Scarica subito la scheda - Routine di mobilità</div>

							<div class="input-grid">
								<div class="form-input">
									<label>Nome</label>
										<input type="name" v-model="formData.name" name="name" placeholder="Nome" required/>
									<label>Cognome</label>
										<input type="name" v-model="formData.surname" name="surname" placeholder="Cognome" required/>
									<label>Email</label>
										<input type="email" v-model="formData.email" name="email" placeholder="Email" required/>
								</div>
								<div class="submit">
									<button>SCARICA SUBITO!</button>
								</div>
							</div>
						</form>
					</div>
				</div>

			<h2 class="section-title" id="gym">La palestra</h2>

			<Slideshow :num-slides="numSlides" :ratio="ratio">
				<SimpleSlide v-for="i in numSlides" :key="i" :background="require(`@/assets/Palestra${i}.jpg`)"/>
			</Slideshow>
		</div>

		<div class="section" id="about">
			<h2 class="section-title">Chi siamo</h2>

			<div class="container-desktop pad-l">
				<div class="p-relative">
					<div class="bar">
						<Card class="bg-darker" title="Federico Magi" :ratio="0.95" :image="require('@/assets/fede-front.jpg')"><p> Lo sport è sempre stata la mia passione principale e questo mi ha portato a conseguire la Laurea Magistrale in Scienze Motorie presso l’ Università degli Studi di Milano. Tutt'ora continuo a formarmi conseguendo diversi certificati e frequentando seminari anche di livello internazionale. Il mio obiettivo è rendere migliore la vita delle persone che si affidano a me, in tutti gli aspetti.</p></Card>
						<Card class="bg-darker" title="Luca Lazzini" :ratio="0.95" :image="require('@/assets/luca-front.jpg')"><p>La passione per lo sport, l'atletica in particolare, mi ha spinto a frequentare la facoltà di Scienze Motorie di Milano dove ho conseguito la Laurea Magistrale. Ho sempre voluto approfondire le mie conoscenze, per questo motivo continuo ad aggiornarmi per offrire sempre il meglio. Credo fortemente che l'attività fisica possa migliorare la qualità della vita delle persone, per questo ogni giorno offro il meglio di me stesso.</p></Card>
					</div>
					<div class="bar">
						<Card class="bg-darker" title="Andrea Bernasconi" :ratio="0.95" :image="require('@/assets/andre-front.jpg')"><p>Ho avuto la fortuna di trasformare la mia grande passione per lo sport nel mio lavoro. Sono laureato magistrale in Scienze Motorie e lavoro nel calcio professionistico come preparatore atletico.“Movement is the key” è il mio motto perché penso che chiunque e a qualunque età debba lavorare sul proprio corpo per la salute e per il miglioramento della performance sportiva.</p></Card>
						<Card class="bg-darker" title="Giorgia Derosa" :ratio="0.95" :image="require('@/assets/Giorgia-front.jpg')"><p>Lo sport ha sempre fatto parte della mia vita, prima come atleta avendo fatto ginnastica artistica e salto con l'asta e ora come lavoro. Questo amore per lo sport mi ha spinto ha iscrivermi a scienze motorie presso l'università cattolica di Milano e di conseguenza a consolidare e perfezionare la mia passione per il calcio, diventando prepratrice atletica professionista tramite il corso a Coverciano. Il mio obiettivo è quello di trasmettere questa mia passione e far star bene le persone, avvicinandone sempre di più a tutto ciò che è movimento e attività fisica.</p></Card>
					</div>
					<div class="bar">
						<Card class="bg-darker" title="Simone Mantovani" :ratio="0.95" :image="require('@/assets/mantovani-front.jpg')"><p>Lo sport è sempre stato, ed è tuttora, un punto chiave della mia vita. Questo mio attaccamento all'attività fisica mi ha spinto a iscrivermi e laurearmi in Scienze Motorie presso l'Università Statale di Milano, percorso che mi ha permesso di trasformare la mia passione nel mio lavoro. Il mio obiettivo è quello di aiutare le persone a raggiungere i propri obiettivi, perché credo fortemente che ogni persona abbia il potenziale per raggiungerli.</p></Card>
						<Card class="bg-darker" title="Riccardo Santi" :ratio="0.95" :image="require('@/assets/riccardo-front.jpg')"><p> </p></Card>
					</div>
					<div class="bar2">
						<Card class="bg-darker" title="Dario Guarnieri" :ratio="0.95" :image="require('@/assets/dario-front.jpg')"><p> </p></Card>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import api from '@/api'
import ShowMore from '@/components/global/ShowMore'
import Card from './Card'

export default {
	name: 'about',

	components: {
		ShowMore,
		Card
	},

	data() {

		return {
			// Number of gym slides
			numSlides: 13,

			/// Image ratio
			ratio: 2.4,

			formData: {
				email: '',
				name: '',
				surname: ''
			}
		}
	},

	methods: {
		/**
		 *
		 */
		attiva_left(){

			var element = document.getElementById("left");
			var element2 = document.getElementById("right");
			var element3 = document.getElementById("form_left");
			var element4 = document.getElementById("form_right");
			var element5 = document.getElementById("routine");
			var element6 = document.getElementById("form_routine");
			var element7 = document.getElementById("estate1");
			var element8 = document.getElementById("form_estate1");
			var element9 = document.getElementById("form_estate2");
			var element10 = document.getElementById("estate2");
			var element11 = document.getElementById("tre");
			var element12 = document.getElementById("form_tre");
			var element13 = document.getElementById("form_quattro");
			var element14 = document.getElementById("quattro");
			element.classList.add("active");
			element2.classList.remove("active");
			element3.classList.add("form_active");
			element4.classList.remove("form_active");
			element5.classList.remove("active");
			element6.classList.remove("form_active");
			element7.classList.remove("active");
			element8.classList.remove("form_active");
			element9.classList.remove("form_active");
			element10.classList.remove("active");
			element11.classList.remove("active");
			element12.classList.remove("form_active");
			element13.classList.remove("form_active");
			element14.classList.remove("active");
		},

		attiva_right(){

			var element = document.getElementById("right");
			var element2 = document.getElementById("left");
			var element3 = document.getElementById("form_right");
			var element4 = document.getElementById("form_left");
			var element5 = document.getElementById("routine");
			var element6 = document.getElementById("form_routine");
			var element7 = document.getElementById("estate1");
			var element8 = document.getElementById("form_estate1");
			var element9 = document.getElementById("form_estate2");
			var element10 = document.getElementById("estate2");
			var element11 = document.getElementById("tre");
			var element12 = document.getElementById("form_tre");
			var element13 = document.getElementById("form_quattro");
			var element14 = document.getElementById("quattro");
			element.classList.add("active");
			element2.classList.remove("active");
			element3.classList.add("form_active");
			element4.classList.remove("form_active");
			element5.classList.remove("active");
			element6.classList.remove("form_active");
			element8.classList.remove("form_active");
			element7.classList.remove("active");
			element9.classList.remove("form_active");
			element10.classList.remove("active");
			element11.classList.remove("active");
			element12.classList.remove("form_active");
			element13.classList.remove("form_active");
			element14.classList.remove("active");
		},

		attiva_tre(){

			var element = document.getElementById("right");
			var element2 = document.getElementById("left");
			var element3 = document.getElementById("form_right");
			var element4 = document.getElementById("form_left");
			var element5 = document.getElementById("routine");
			var element6 = document.getElementById("form_routine");
			var element7 = document.getElementById("estate1");
			var element8 = document.getElementById("form_estate1");
			var element9 = document.getElementById("form_estate2");
			var element10 = document.getElementById("estate2");
			var element11 = document.getElementById("tre");
			var element12 = document.getElementById("form_tre");
			var element13 = document.getElementById("form_quattro");
			var element14 = document.getElementById("quattro");
			element11.classList.add("active");
			element2.classList.remove("active");
			element3.classList.remove("form_active");
			element.classList.remove("active");
			element12.classList.add("form_active");
			element4.classList.remove("form_active");
			element5.classList.remove("active");
			element6.classList.remove("form_active");
			element8.classList.remove("form_active");
			element7.classList.remove("active");
			element9.classList.remove("form_active");
			element10.classList.remove("active");
			element13.classList.remove("form_active");
			element14.classList.remove("active");
		},

		attiva_quattro(){

			var element = document.getElementById("right");
			var element2 = document.getElementById("left");
			var element3 = document.getElementById("form_right");
			var element4 = document.getElementById("form_left");
			var element5 = document.getElementById("routine");
			var element6 = document.getElementById("form_routine");
			var element7 = document.getElementById("estate1");
			var element8 = document.getElementById("form_estate1");
			var element9 = document.getElementById("form_estate2");
			var element10 = document.getElementById("estate2");
			var element11 = document.getElementById("tre");
			var element12 = document.getElementById("form_tre");
			var element13 = document.getElementById("form_quattro");
			var element14 = document.getElementById("quattro");
			element14.classList.add("active");
			element13.classList.add("form_active");
			element11.classList.remove("active");
			element2.classList.remove("active");
			element3.classList.remove("form_active");
			element.classList.remove("active");
			element12.classList.remove("form_active");
			element4.classList.remove("form_active");
			element5.classList.remove("active");
			element6.classList.remove("form_active");
			element8.classList.remove("form_active");
			element7.classList.remove("active");
			element9.classList.remove("form_active");
			element10.classList.remove("active");
		},

		attiva_routine(){

			var element = document.getElementById("right");
			var element2 = document.getElementById("left");
			var element5 = document.getElementById("routine");
			var element3 = document.getElementById("form_right");
			var element4 = document.getElementById("form_left");
			var element6 = document.getElementById("form_routine");
			var element7 = document.getElementById("estate1");
			var element8 = document.getElementById("form_estate1");
			var element9 = document.getElementById("form_estate2");
			var element10 = document.getElementById("estate2");
			var element11 = document.getElementById("tre");
			var element12 = document.getElementById("form_tre");
			var element13 = document.getElementById("form_quattro");
			var element14 = document.getElementById("quattro");
			element.classList.remove("active");
			element2.classList.remove("active");
			element3.classList.remove("form_active");
			element4.classList.remove("form_active");
			element5.classList.add("active");
			element6.classList.add("form_active");
			element8.classList.remove("form_active");
			element7.classList.remove("active");
			element9.classList.remove("form_active");
			element10.classList.remove("active");
			element11.classList.remove("active");
			element12.classList.remove("form_active");
			element13.classList.remove("form_active");
			element14.classList.remove("active");
		},

		attiva_estate1(){

			var element = document.getElementById("right");
			var element2 = document.getElementById("left");
			var element5 = document.getElementById("routine");
			var element3 = document.getElementById("form_right");
			var element4 = document.getElementById("form_left");
			var element6 = document.getElementById("form_routine");
			var element7 = document.getElementById("form_estate1");
			var element8 = document.getElementById("estate1");
			var element9 = document.getElementById("estate2");
			var element10 = document.getElementById("form_estate2");
			var element11 = document.getElementById("tre");
			var element12 = document.getElementById("form_tre");
			element.classList.remove("active");
			element2.classList.remove("active");
			element3.classList.remove("form_active");
			element4.classList.remove("form_active");
			element5.classList.remove("active");
			element6.classList.remove("form_active");
			element8.classList.add("active");
			element7.classList.add("form_active");
			element9.classList.remove("active");
			element10.classList.remove("form_active");
			element11.classList.remove("active");
			element12.classList.remove("form_active");
		},

		attiva_estate2(){

			var element = document.getElementById("right");
			var element2 = document.getElementById("left");
			var element5 = document.getElementById("routine");
			var element3 = document.getElementById("form_right");
			var element4 = document.getElementById("form_left");
			var element6 = document.getElementById("form_routine");
			var element7 = document.getElementById("form_estate1");
			var element8 = document.getElementById("estate1");
			var element9 = document.getElementById("estate2");
			var element10 = document.getElementById("form_estate2");
			var element11 = document.getElementById("tre");
			var element12 = document.getElementById("form_tre");
			
			element.classList.remove("active");
			element2.classList.remove("active");
			element3.classList.remove("form_active");
			element4.classList.remove("form_active");
			element5.classList.remove("active");
			element6.classList.remove("form_active");
			element8.classList.remove("active");
			element7.classList.remove("form_active");
			element9.classList.add("active");
			element10.classList.add("form_active");
			element11.classList.remove("active");
			element12.classList.remove("form_active");
		},


		onResize() {

			if (window.innerWidth < 640)
				this.ratio = 1.4
			else
				this.ratio = 2.4
		},

		async submitEbook1() {
			
			try
			{
				await api.make('POST', /* endpoint */'/public/ebook1', /* data */{
					email: this.formData.email,
					name: this.formData.name,
					surname: this.formData.surname
				}, /* bJson */true)

				/*notif.done('Grazie! La tua richiesta è stata inoltrata')*/
				this.$router.push('grazie')
			}
			catch (e)
			{
				/*console.error('console error')
				notif.error('notif error')*/

  				/*document.getElementById("messaggio").style.display = "block";*/

				/*this.$router.push('thankyou')*/

			}
		},

		async submitEbook2() {
			
			try
			{
				await api.make('POST', /* endpoint */'/public/ebook2', /* data */{
					email: this.formData.email,
					name: this.formData.name,
					surname: this.formData.surname
				}, /* bJson */true)

				/*notif.done('Grazie! La tua richiesta è stata inoltrata')*/
				this.$router.push('grazie-2')
			}
			catch (e)
			{
				/*console.error('console error')
				notif.error('notif error')*/

  				/*document.getElementById("messaggio").style.display = "block";*/

				/*this.$router.push('thankyou')*/

			}
		},

		async submitEbook3() {
			
			try
			{
				await api.make('POST', /* endpoint */'/public/ebook3', /* data */{
					email: this.formData.email,
					name: this.formData.name,
					surname: this.formData.surname
				}, /* bJson */true)

				/*notif.done('Grazie! La tua richiesta è stata inoltrata')*/
				this.$router.push('grazie-new')
			}
			catch (e)
			{
				/*console.error('console error')
				notif.error('notif error')*/

  				/*document.getElementById("messaggio").style.display = "block";*/

				/*this.$router.push('thankyou')*/

			}
		},

		async submitEbookKnee() {
			
			try
			{
				await api.make('POST', /* endpoint */'/public/ebook_knee', /* data */{
					email: this.formData.email,
					name: this.formData.name,
					surname: this.formData.surname
				}, /* bJson */true)

				/*notif.done('Grazie! La tua richiesta è stata inoltrata')*/
				this.$router.push('grazie-ginocchia')
			}
			catch (e)
			{
				/*console.error('console error')
				notif.error('notif error')*/

  				/*document.getElementById("messaggio").style.display = "block";*/

				/*this.$router.push('thankyou')*/

			}
		},

		async submitScheda() {
			
			try
			{
				await api.make('POST', /* endpoint */'/public/scheda', /* data */{
					email: this.formData.email,
					name: this.formData.name,
					surname: this.formData.surname
				}, /* bJson */true)

				/*notif.done('Grazie! La tua richiesta è stata inoltrata')*/
				this.$router.push('grazie-3')
			}
			catch (e)
			{
				/*console.error('console error')
				notif.error('notif error')*/

  				/*document.getElementById("messaggio").style.display = "block";*/

				/*this.$router.push('thankyou')*/

			}
		},

		async submitEstate1() {
			
			try
			{
				await api.make('POST', /* endpoint */'/public/estate1', /* data */{
					email: this.formData.email,
					name: this.formData.name,
					surname: this.formData.surname
				}, /* bJson */true)

				/*notif.done('Grazie! La tua richiesta è stata inoltrata')*/
				this.$router.push('grazie-4')
			}
			catch (e)
			{
				/*console.error('console error')
				notif.error('notif error')*/

  				/*document.getElementById("messaggio").style.display = "block";*/

				/*this.$router.push('thankyou')*/

			}
		},

		async submitEstate2() {
			
			try
			{
				await api.make('POST', /* endpoint */'/public/estate2', /* data */{
					email: this.formData.email,
					name: this.formData.name,
					surname: this.formData.surname
				}, /* bJson */true)

				/*notif.done('Grazie! La tua richiesta è stata inoltrata')*/
				this.$router.push('grazie-5')
			}
			catch (e)
			{
				/*console.error('console error')
				notif.error('notif error')*/

  				/*document.getElementById("messaggio").style.display = "block";*/

				/*this.$router.push('thankyou')*/

			}
		}
	},

	created() {

		window.addEventListener('resize', this.onResize)
		this.onResize()
	},

	destroyed() {

		window.removeEventListener('resize', this.onResize)
	}
}
</script>

<style lang="stylus" scoped>
.gridebook
	background-color #101418
	padding 1em

.ebook1
	display none

.form_active
	display grid

.itemebook 
	img
		max-width 9em
		cursor pointer
		border 3px solid transparent

		@media (max-width: unit(768, px))
			display block
			margin 20px auto

	img:hover
		border 3px solid #ffe010
		border-radius 5px

	.left
		margin-right 1em

		@media (max-width: unit(768, px))
			margin 20px auto

	.active
		border 3px solid #ffe010
		border-radius 5px

.bar
	display grid
	grid-template-columns repeat(2, 1fr)
	grid-gap 1em

	padding 1em

	@media (max-width: unit(768, px))
		grid-template-columns auto

.bar2
	display grid
	grid-template-columns auto
	grid-gap 1em

	padding 1em

	max-width 50%
	margin 0 auto

	@media (max-width: unit(768, px))
		grid-template-columns auto
		max-width 100%

.info
	padding 1em 1.5em

	background repeating-linear-gradient(45deg, rgba(dark, 0), rgba(dark, 0) 1.6em, rgba(dark, 0.5) 1.6em, rgba(dark, 0.5) 3.2em)

	font-family fontSans
	font-size 1.2em

.divprova
	max-width 100%
	padding 2em
	text-align center

.provagratuita
	max-width 600px

	padding 0.6em
	border none

	background-color primary
	color dark

	font-family fontSans
	font-size 1.6em

	cursor pointer

	transition 0.2s ease

	&:focus
		outline none

.contact-form
		grid-column 1/5

		margin 1.5em
		padding 2em

		background-color dark

		.title
			font-size 1.2em
		
		.input-grid
			margin-top 1.5em

			.form-input
				margin 0.5em 0

				box-sizing border-box
				
				label
					display block

					margin-bottom 0.4em

					font-size 0.8em

				input
					width 100%

					display block
				
					padding 0.4em 0.6em
					border none
					border-bottom 2px solid transparent
					box-sizing border-box

					background-color darkish
					color light

					font-size 1.2em

					transition 0.2s ease

					&:focus
						outline none
						border-bottom 2px solid primary
			
			.submit
				margin-top 4em

				button
					width 100%

					padding 0.6em
					border none

					background-color primary
					color dark

					font-family fontSans
					font-size 1.3em

					cursor pointer

					transition 0.2s ease

					&:focus
						outline none

</style>